<div class="wrapper">
  <inf-master-detail
    [manager]="tableManager"
    [options]="tableOptions"
    (selectRow)="onSelectRow($event)"
    (rowClick)="onRowClick($event)"
    (actionClick)="onActionClick($event)"
    [dimension]="{ width: 350 }"
  >
    @if (entity) {
      <infl-standard-page-detail
        [CRUD]="CRUD"
        [entity]="entity"
        [factory]="factory"
        [model]="model"
        (actionClick)="onActionClick($event)"
      />
    }
  </inf-master-detail>
</div>
